import React from 'react';
import { useSelector } from 'react-redux';

import GroupWithNodes from './GroupWithNodes';

import scss from './BenchmarksNodeList.module.scss';

function BenchmarksNodeList({ search, selectedNodes, onSelectNode }) {
  const filterColumns = useSelector((state) => state.resonance.filterColumns);

  const searchedNodes = filterColumns.reduce((acc, curr) => {
    const audiences = curr.audiences;

    const filteredAudiences = audiences.filter((audience) => searchNodes(audience, search));

    acc.push({
      name: curr.header,
      options: filteredAudiences,
    });
    return acc;
  }, []);

  const handleSelectNode = (node) => {
    onSelectNode(node);
  };

  return (
    <div className={scss.wrapper}>
      {searchedNodes.map(({ name, options }) => (
        <GroupWithNodes
          key={name}
          label={name}
          options={options}
          selectedOptions={selectedNodes}
          onSelect={handleSelectNode}
          search={search}
        />
      ))}
    </div>
  );
}

export default BenchmarksNodeList;

const searchNodes = (node, search) => {
  if (!search) {
    return true;
  }

  const { subheader } = node;

  return subheader?.toLowerCase().includes(search.toLowerCase());
};
